export default __webpack_public_path__ + "static/media/Water Quality Issues 4c8f1b9fff9e44509b3b62dde3c995a0.89bd9d1f.md";